(function() {
  // Otimizador de Performance
  const performanceOptimizer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {  // Element node
          // Otimiza apenas imagens grandes de produto/banner
          if (node.tagName === 'IMG') {
            // Aplica lazy loading sem remover src
            if (!node.hasAttribute('loading')) {
              node.setAttribute('loading', 'lazy');
            }
          }
          // Otimiza links
          if (node.tagName === 'LINK' && node.rel === 'stylesheet' && !node.dataset.critical) {
            node.media = 'print';
            node.onload = function() {
              this.media = 'all';
            };
          }
        }
      });
    });
  });

  // Inicia observação do DOM
  performanceOptimizer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Otimiza imagens existentes
  document.querySelectorAll('img').forEach(function(img) {
    if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
    }
  });

  // Otimiza carregamento crítico
  window.addEventListener('load', function() {
    document.querySelectorAll('script:not([type="application/json"])').forEach(function(script) {
      if (!script.src || script.defer || script.async) return;
      script.defer = true;
    });
  });
})();